<mat-form-field
  color="accent"
  class="number-input"
  appearance="outline"
  subscriptSizing="dynamic"
>
  <input
    #numberInput="ngModel"
    matInput
    [name]="name"
    type="number"
    class="form-control"
    [(ngModel)]="value"
    (input)="onChange()"
    [min]="min"
    [max]="max"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    role="spinbutton"
    [attr.aria-valuenow]="value"
    [attr.aria-valuemin]="min"
    [attr.aria-valuemax]="max"
    (keydown)="onKeydown($event)"
  />
  <div matSuffix class="number-input-buttons">
    <button
      type="button"
      (click)="valueUp()"
      [disabled]="disabled"
      aria-label="Increase value"
    >
      <i class="fa fa-caret-up" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      (click)="valueDown()"
      [disabled]="disabled"
      aria-label="Decrease value"
    >
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </button>
  </div>
</mat-form-field>
